export const profiles = Object.freeze({
    Generic: 0,
    OralWritternBoard: 1,
    OpenEvent: 2,
    PSTM: 3
});